<template>
  <div class="data-table" :style=" { maxHeight: maxHeight, overflowY: maxHeight? 'auto' : 'none'}">
    <!-- Заголовок таблицы -->
    <div v-if="!props.noHeader" class="table-header">
      <div class="header-row" :style="{height: props.heightHeader  + 'px' }">
        <div
            v-for="header in computedHeaders"
            :key="header.value"
            class="header-cell"
            :style="{ width: header.width || 'auto', textAlign: header.align || 'left' }"
            @click="sortBy(header.value, header.text)"
        >
          <span>{{ header.text }}</span>

<!--          <div class="info" v-if="header.info">-->
<!--            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M8.00016 15.1673C11.6821 15.1673 14.6668 12.1825 14.6668 8.50065C14.6668 4.81875 11.6821 1.83398 8.00016 1.83398C4.31826 1.83398 1.3335 4.81875 1.3335 8.50065C1.3335 12.1825 4.31826 15.1673 8.00016 15.1673Z" fill="#8F9CAC"/>-->
<!--              <path d="M8.00684 11.166L8.00684 8.49935" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--              <path d="M8.00684 5.83203L8.00017 5.83203" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--            </svg>-->

<!--          </div>-->
          <div @mouseleave="title = ''" @mousemove="title = header.value" class="data-table__hover-menu info" v-if="header.info">
            <img src="@/assets/images/icons/info.svg" alt="title" />
            <div v-if="title === header.value" class="data-table__hover-title">{{header.info}}</div>
          </div>


          <div class="data-table__item-icons">
            <span class="data-table__item-sort_asc">
              <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.75 4.32812L4.5 1.07813L1.25 4.32812"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                        :stroke="sortDesc && sortDesc !== 'none' && sortedField === header.text? '#1E3959' : '#8F9CAC'"/>
              </svg>
            </span>
            <span class="data-table__item-sort_desc">
              <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.25 1.66406L4.5 4.91406L7.75 1.66406"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                      :stroke="!sortDesc && sortDesc !== 'none' && sortedField === header.text? '#1E3959' : '#8F9CAC'"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Тело таблицы -->
    <div class="table-body">
      <div
          v-for="(item, index) in paginatedItems"
          :key="index"
          class="body-row"
          :style="{ height: heightRow + 'px' }"
          @click="selectItem(item)"
      >
<!--        :class="{ 'selected': isSelected(item) }"-->
        <div
            v-for="(header) in computedHeaders"
            :key="header.value"
            :class="index % 2 === 0 ? '' : 'body-cell-zebra'"
            class="body-cell"
            :style="{ width: header.width || 'auto', textAlign: header.align || 'left' }"
        >
          <slot :name="`item.${header.value}`" :item="item">
            {{ item[header.value] }}
          </slot>
        </div>
      </div>
    </div>

    <!-- Пагинация -->
    <div v-if="pagination" class="table-footer">
      <div class="pagination-controls">
        <button @click="prevPage" :disabled="currentPage === 1">Назад</button>
        <span>Страница {{ currentPage }} из {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage === totalPages">Вперед</button>
      </div>
      <div class="items-per-page">
        <select v-model="itemsPerPage">
          <option v-for="option in itemsPerPageOptions" :key="option" :value="option">
            {{ option }} на страницу
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
const title = ref()
const props = defineProps({
  headers: {
    type: Array,
    required: true,
    default: () => []
  },
  items: {
    type: Array,
    required: true,
    default: () => []
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  pagination: {
    type: Boolean,
    default: true
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [5, 10, 15, 20, 25]
  },
  sortBy: {
    type: String,
    default: ''
  },
  sortDesc: {
    type: Boolean,
    default: false
  },
  singleSelect: {
    type: Boolean,
    default: false
  },
  noHeader: {
    type: Boolean,
    default: false
  },
  heightHeader: {
    type: [Number, String],
    default: 49
  },
  heightRow: {
    type: [Number, String],
    default: 41
  },
  maxHeight: {
    type: Number,
    default: 'auto'
  }
})

const emit = defineEmits(['update:modelValue', 'update:sortBy', 'update:sortDesc'])

const currentPage = ref(1)
const itemsPerPage = ref(props.itemsPerPageOptions[0])
const internalSortBy = ref(props.sortBy)
const internalSortDesc = ref(props.sortDesc)
const selectedItems = ref([...props.modelValue])

const computedHeaders = computed(() => {
  return props.headers.map(header =>
      typeof header === 'string' ? { text: header, value: header } : header
  )
})

const sortedItems = computed(() => {
  if (!internalSortBy.value) return props.items
  if(internalSortDesc.value === 'none')
    return [...props.items]
  return [...props.items].sort((a, b) => {
    const aValue = a[internalSortBy.value]
    const bValue = b[internalSortBy.value]

    if (aValue < bValue) return internalSortDesc.value ? 1 : -1
    if (aValue > bValue) return internalSortDesc.value ? -1 : 1
    return 0
  })
})

const paginatedItems = computed(() => {
  if (!props.pagination) return sortedItems.value

  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return sortedItems.value.slice(start, end)
})

const totalPages = computed(() => {
  return Math.ceil(props.items.length / itemsPerPage.value)
})

watch(itemsPerPage, () => {
  currentPage.value = 1
})

watch(() => props.modelValue, (newVal) => {
  selectedItems.value = [...newVal]
})

watch(selectedItems, (newVal) => {
  emit('update:modelValue', [...newVal])
})

watch(internalSortBy, (newVal) => {
  emit('update:sortBy', newVal)
})

watch(internalSortDesc, (newVal) => {
  emit('update:sortDesc', newVal)
})

const sortedField = ref('')

function sortBy(field, fieldName) {
  sortedField.value = fieldName
  if (internalSortBy.value === field) {
    if(internalSortDesc.value && internalSortDesc.value !== 'none') {
      internalSortDesc.value = false
    } else if (!internalSortDesc.value) {
      internalSortDesc.value = 'none'
    } else {
      internalSortDesc.value = true
    }
  } else {
    internalSortBy.value = field
    internalSortDesc.value = false
  }
}

function prevPage() {
  if (currentPage.value > 1) currentPage.value--
}

function nextPage() {
  if (currentPage.value < totalPages.value) currentPage.value++
}

function selectItem(item) {
  if (props.singleSelect) {
    selectedItems.value = [item]
  } else {
    const index = selectedItems.value.findIndex(selected => selected === item)
    if (index === -1) {
      selectedItems.value.push(item)
    } else {
      selectedItems.value.splice(index, 1)
    }
  }
}

function isSelected(item) {
  return selectedItems.value.includes(item)
}
</script>

<style lang="scss" scoped>
.data-table {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  overflow: auto;

  &__hover-menu {
    position: relative;
  }

  &__hover-title {
    position: absolute;
    padding: 12px 16px;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    right: -55px;
    z-index: 11;
    top: 20px;
    border: 1px solid $light-gray-2;
    border-radius: 8px;
    background-color: white;
  }

  &__item-icons {
    display: flex;
    flex-direction: column;
    margin-left: 6px;
    padding: 1px 3px;
    width: 17px;
    height: 17px;
  }

  &__item-sort {
    &_asc {
      margin-top: 2px;
      display: block;
      height: 5px;

      margin-bottom: 3px;
      flex-shrink: 0;
      overflow: hidden;

      &>svg {
        width: 11px;
        max-height: 20px;
      }
    }

    &_desc {
      display: block;
      height: 7px;
      flex-shrink: 0;
      overflow: hidden;

      &>svg {
        width: 11px;
        max-height: 20px;
      }

    }
  }

}

.table-header {
  //background-color: #f5f5f5;
  font-size: 12px;
  color: $grey-text;
}

.body-row {
  display: flex;
  &:not(:last-child) {
    border-bottom: 1px solid $grey-main; // Граница для всех, кроме последнего
  }
}

.header-row {
  display: flex;
  border-bottom: 1px solid $grey-main;
}

.header-cell, .body-cell {
  padding: 12px 24px;
  flex-grow: 1;

}

.body-cell-zebra {
  background-color: $light;
}

.header-cell {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.header-cell:hover {
  //background-color: #eeeeee;
}

.sort-icon {
  margin-left: 8px;
}

.body-row:hover {
  //background-color: #f9f9f9;
}

.body-row.selected {
  background-color: #e3f2fd;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-controls button {
  padding: 4px 8px;
  cursor: pointer;
}

.pagination-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.items-per-page select {
  padding: 4px 8px;
}

.info {
  margin-left: 6px;
  margin-top: 5px;
}

</style>